import { ConditionalDisplay } from '@rsos/base-components';
import { UNITE_SUMMARIZATION_AND_KEYWORDS } from '@rsos/capstone/src/constants/capabilities';
import { MANAGE_KEYWORDS } from '@rsos/constants/pageAccess';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import styles from '../settings.module.css';
import { KeywordBannerSettings } from './KeywordBannerSettings/KeywordBannerSettings';

export const KeywordSettings = () => {
  const hasUniteSummarizationAndKeywordsCapabilities = useHasCapability(
    UNITE_SUMMARIZATION_AND_KEYWORDS,
  ).hasCapability;
  const canManageKeywords = useHasPermission(MANAGE_KEYWORDS);

  return (
    <ConditionalDisplay
      dataName="keyword-settings"
      conditions={[
        {
          showIf: !!hasUniteSummarizationAndKeywordsCapabilities,
          reason: 'Needs unite_summarization_and_keywords capability',
        },
        {
          showIf: !!canManageKeywords,
          reason: 'Needs MANAGE KEYWORDS permission',
        },
      ]}
    >
      <div className={styles.section}>
        <h2 className={styles.title}>Keywords</h2>
        <div className={styles.description}>
          Manage notifications for keywords detected within live 911 call
          transcriptions.
        </div>
        <div className={styles.cardBlock}>
          <KeywordBannerSettings />
        </div>
      </div>
    </ConditionalDisplay>
  );
};
